<template>
    <div class="as-app-sort-options">
        <div class="select-input">
            <select v-model="sortEnum">
                <option v-for="option in sortOptions" :value="option.id"
                        :key="option.id">
                    {{option.label}}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default {
        name: 'SortOptions',
        props: {

        },
        data() {
            return {
                sortOptions : []
            }
        },
        methods: {
            cleanParamValueObjects(arr, sort, lowest, highest) {
                // Cleans duplicate entries of the taxonomy request and as well removes object with paramValue 'Unknown' or empty label.
                let tempArray
                if (arr.length > 0) {
                    tempArray = arr.filter((arritem, index, self) =>
                        index === self.findIndex((f) => (
                            (f.paramValue === arritem.paramValue && f.label.de_DE === arritem.label.de_DE) || arritem.paramValue === 'Unknown' || arritem.paramValue === null || arritem.paramValue === 'null' || arritem.label === ''
                        ))
                    )
                }

                if (tempArray.length > 0) {
                    if (typeof lowest !== 'undefined') {
                        tempArray = tempArray.filter((arritem) => arritem.paramValue >= lowest)
                    }
                    if (typeof highest !== 'undefined') {
                        tempArray = tempArray.filter((arritem) => arritem.paramValue <= highest)
                    }
                }


                if (sort === 'asc' || sort === 'desc') {
                    tempArray.sort(this.compare);
                    if (sort === 'desc') tempArray.reverse()
                } else if (typeof sort !== 'undefined') {
                    console.log('Wrong sortdirection. \'asc\' or \'desc\'');
                }
                return tempArray
            },
            compare(a, b) {
                if (a.paramValue < b.paramValue) {
                    return -1;
                }
                if (a.paramValue > b.paramValue) {
                    return 1;
                }
                return 0;
            },
        },
        computed: {

            ////////////////////////////
            // Possible inputs values //
            ////////////////////////////

            sortByInputValues: {
                get() {
                    return this.sortOptions.sortBy
                },
                set(val) {
                    this.sortOptions.sortBy = val
                }
            },
            sortOrderInputValues: {
                get() {
                    return this.sortOptions.sortOrder
                },
                set(val) {
                    this.sortOptions.sortOrder = val
                }
            },


            //////////////////////////
            // Actual inputs values //
            //////////////////////////


            sortEnum: {
                get() {
                    return this.$store.state.searchParams.sortObjectProxy.id
                },
                set(val) {
                    this.$store.commit('onSortChange')
                    //Search object in SortOptionsarray by val
                    let sortObject = this.sortOptions.find(function(element){
                        return element.id === val
                    })
                    this.$store.commit('updateSearchParams', {sortObjectProxy: sortObject}) //Build object that will be merged into state.searchParams
                }
            },

        },
        apollo: {
            ///////////////////////////////////////
            // Get possible InputValues from API //
            ///////////////////////////////////////

            sortOptions: {
                query: require('../graphql/SortOptions.gql'),
                errorPolicy: 'all',
                fetchPolicy: 'no-cache',
                manual: true,
                error(error) {
                    // console.log({error})
                    if(parseInt(error.networkError.statusCode) === 429){
                        Vue.logApiLimitReached();
                    }
                },
                result(data) {
                    // console.log(data.loading);
                    if (typeof data.error === 'undefined' && typeof data.data !== 'undefined' && !data.loading) {
                        let self = this
                        this.cleanParamValueObjects(data.data.sortOptions.filters.sortingKey.values).forEach(function(sortByValue, index){
                            let outerindex = index;
                            self.cleanParamValueObjects(data.data.sortOptions.filters.sortingOrder.values).forEach(function(sortOrderValue, index){
                                // self.sortOptions[sortByValue.paramValue+'-'+sortOrderValue.paramValue] = {
                                //     label: sortByValue.label.de_DE+'&nbsp;'+sortOrderValue.label.de_DE,
                                //     value: sortByValue.label.de_DE+'-'+sortOrderValue.label.de_DE,
                                //     sortBy: sortByValue.paramValue,
                                //     sortOrder: sortOrderValue.paramValue
                                // }
                                self.sortOptions.push({
                                    id: outerindex+'-'+index,
                                    label: sortByValue.label.de_DE+' '+sortOrderValue.label.de_DE,
                                    sortBy: sortByValue.paramValue,
                                    sortOrder: sortOrderValue.paramValue
                                })
                            })
                        })  // Remove duplicate entries

                        //console.log(self.sortOptions);
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../styles/style.scss";
    @import "../styles/partials/_sort-options";
</style>